var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "edit-line" },
    [
      !_vm.isReadOnlyUser
        ? _c(
            "md-button",
            {
              class: _vm.useIcon
                ? "md-warning md-just-icon md-round"
                : "" + _vm.className,
              attrs: {
                title: "Edit service details",
                disabled: _vm.isDisabled,
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.handleUpdateService($event)
                },
              },
            },
            [
              _vm.useIcon
                ? _c("md-icon", [_vm._v("edit")])
                : _c("span", [_vm._v("Edit")]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }